import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Tooltip, Box } from '@mui/material';
import { RegisterFormTooltipContext } from 'src/context/RegisterFormTooltipContext';
import { getRegisterFormTooltipByKey } from 'src/constants/registerFormTooltips';

const StyledTextField = styled((props) => <TextField {...props} />)(({ theme }) => ({
  '& .MuiOutlinedInput-input::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '0.8',
  },
  '& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder': {
    color: theme.palette.text.secondary,
    opacity: '1',
  },
  '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.grey[200],
  },
}));

const CustomTextField = ({ tooltip, tooltipKey, ...props }) => {
  const { enabled, defaultTooltip } = useContext(RegisterFormTooltipContext);
  const resolvedTooltip =
    tooltip || (tooltipKey ? getRegisterFormTooltipByKey(tooltipKey) : '');
  const tooltipText = resolvedTooltip || (enabled ? defaultTooltip : '');
  const textField = <StyledTextField {...props} />;

  if (!tooltipText) {
    return textField;
  }

  return (
    <Tooltip title={tooltipText}>
      <Box sx={{ width: '100%' }}>
        {textField}
      </Box>
    </Tooltip>
  );
};

export default CustomTextField;
